import { enc, MD5 } from "crypto-js";
import * as httpHelper from "../../utils/http-helper";

function login(cpf: string, senha: string) {
  const headers = httpHelper.defaultHeaders();

  const params = {
    CPF: cpf,
    Senha: MD5(senha).toString(enc.Hex).toUpperCase(),
  };

  return httpHelper.post(headers, params, "Usuario/ValidarLogin");
}

function aceitarPolitica(cpf: string) {
  const headers = httpHelper.defaultHeaders();

  const params = {
    Login: cpf,
  };

  return httpHelper.post(headers, params, "Cooperado/SalvarConsentimentoLGPD");
}

const loginService = {
  login,
  aceitarPolitica,
};

export default loginService;
